import * as Yup from 'yup';
import { TFunction } from 'react-i18next';
import { Shape } from '../yup_types';
import { PASSWORD_REG_EXP } from '../../components/auth/PasswordStrength/PasswordStrength';

export enum FORGOT_PASSWORD_FORM_FIELDS {
	EMAIL = 'email',
	CODE = 'code',
	NEW_PASSWORD = 'newPassword',
	CONFIRM_PASSWORD = 'confirmPassword'
}

export enum FORGOT_PASSWORD_FORM_FIELDS_NAMES {
  EMAIL = 'FORGOT_PASSWORD.EMAIL',
	CODE = 'FORGOT_PASSWORD.CODE',
	NEW_PASSWORD = 'FORGOT_PASSWORD.NEW_PASSWORD',
	CONFIRM_PASSWORD = 'FORGOT_PASSWORD.CONFIRM_PASSWORD'
}

export type ForgotPasswordFieldsTypes = {
	[FORGOT_PASSWORD_FORM_FIELDS.EMAIL]: string,
}

export type ForgotPasswordConfirmFieldsTypes = {
	[FORGOT_PASSWORD_FORM_FIELDS.EMAIL]: string,
	[FORGOT_PASSWORD_FORM_FIELDS.CODE]: string,
	[FORGOT_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: string,
	// [FORGOT_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]?: string,
}

export type ForgotPasswordReturnTypes = {
	email: string,
}

export const forgotPasswordConfirmInitialValues: ForgotPasswordConfirmFieldsTypes = {
	[FORGOT_PASSWORD_FORM_FIELDS.EMAIL]: '',
	[FORGOT_PASSWORD_FORM_FIELDS.CODE]: '',
	[FORGOT_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: '',
	// [FORGOT_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: '',
};

export const getForgotPasswordDetailSchema = (t: TFunction): Yup.SchemaOf<ForgotPasswordFieldsTypes> => Yup.object<Shape<ForgotPasswordFieldsTypes>>().shape({
	[FORGOT_PASSWORD_FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
});

export const getForgotPasswordConfirmDetailSchema = (t: TFunction): Yup.SchemaOf<ForgotPasswordConfirmFieldsTypes> => Yup.object<Shape<ForgotPasswordConfirmFieldsTypes>>().shape({
	[FORGOT_PASSWORD_FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
	[FORGOT_PASSWORD_FORM_FIELDS.CODE]: Yup.string()
		.required('Code is required'),
	[FORGOT_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: Yup.string()
		.matches(PASSWORD_REG_EXP.latter, 'New Password should contain at least one letter')
		.matches(PASSWORD_REG_EXP.uppercase, 'New Password should contain at least one uppercase letter')
		.matches(PASSWORD_REG_EXP.number, 'New Password should contain at least one number')
		.matches(PASSWORD_REG_EXP.symbol, 'New Password should contain at least one special symbol')
		.matches(PASSWORD_REG_EXP.complete, 'New Password is not valid')
		.min(8, 'New Password should have at least 8 symbols')
		.max(50, 'New Password shouldn`t have more than 50 symbols')
		.required('New Password is required'),
	// [FORGOT_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: Yup.string()
	// 	.oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
	// 	.required('Confirm password is required'),
});

export const forgotPasswordInitialValues: ForgotPasswordFieldsTypes = {
	[FORGOT_PASSWORD_FORM_FIELDS.EMAIL]: '',
};

export const getFormattedForgotPasswordConfirmFormFields = (formikValues): any => ({
	username: formikValues?.[FORGOT_PASSWORD_FORM_FIELDS.EMAIL],
	resetCode: formikValues?.[FORGOT_PASSWORD_FORM_FIELDS.CODE],
	newPassword: formikValues?.[FORGOT_PASSWORD_FORM_FIELDS.NEW_PASSWORD]

});
